import { Action } from "redux";

export type IActionTypes = "HEADER_STATE_RECEIVED";

export const actionTypes: { [key in IActionTypes]: key } = {
  HEADER_STATE_RECEIVED: "HEADER_STATE_RECEIVED",
};

export interface IHeaderPayload {
  isSticky?: boolean;
  topOffset?: number;
  topVisibleOffset?: number;
  height?: number;
}

export interface ISetHeader extends Action {
  payload: IHeaderPayload;
}

export const setHeader = (payload: IHeaderPayload): ISetHeader => ({
  payload,
  type: actionTypes.HEADER_STATE_RECEIVED,
});
